module.exports = __webpack_public_path__ + "img/bg4.83991777.png";